import { QuestionLabel, SimpleTitle } from '@amo/core/components/containers';
import { Text } from '@amo/core/components/forms';
import { normalizeEmail, normalizeTel } from '@amo/core/utils/normalize';
import { required, validateEmail, validatePhone } from '@amo/core/utils/validateField';
import { Field } from 'redux-form';

/**
 * Coordonnées du conseiller courtier / concessionnaire à l'origine de la demande
 * de rappel. Les 4 champs sont obligatoires côté formulaire (le bouton « Être
 * recontacté » reste désactivé tant qu'ils ne sont pas remplis) ; devis-ws et
 * deals les gardent volontairement facultatifs, cf. le commentaire dans
 * `formatContactOrange` de devis-ws.
 */
const ContactOrange = () => (
    <div className={'bg-light p-4 rounded text-start mt-5'}>
        <SimpleTitle className={'mt-0'}>Vos coordonnées</SimpleTitle>
        <p className={'m-0 text-grey'}>
            <small>Renseignez vos coordonnées pour que notre conseiller puisse vous joindre au sujet de cette demande.</small>
        </p>

        <div className={'row'}>
            <div className={'col-12 col-md-6'}>
                <QuestionLabel className={'f-14 mt-4'} required>
                    Nom&nbsp;
                </QuestionLabel>
                <Field
                    component={Text}
                    name={'DemandeDevis[ContactOrange][Nom]'}
                    validate={[required]}
                    normalize={(v) => (v || '').toUpperCase()}
                />
            </div>

            <div className={'col-12 col-md-6'}>
                <QuestionLabel className={'f-14 mt-4'} required>
                    Prénom&nbsp;
                </QuestionLabel>
                <Field component={Text} name={'DemandeDevis[ContactOrange][Prenom]'} validate={[required]} />
            </div>

            <div className={'col-12 col-md-6'}>
                <QuestionLabel className={'f-14 mt-4'} required>
                    N° de téléphone&nbsp;
                </QuestionLabel>
                <Field
                    component={Text}
                    name={'DemandeDevis[ContactOrange][Telephone]'}
                    icon={'phone'}
                    iconSize={18}
                    validate={[required, validatePhone]}
                    normalize={normalizeTel}
                />
            </div>

            <div className={'col-12 col-md-6'}>
                <QuestionLabel className={'f-14 mt-4'} required>
                    Adresse e-mail&nbsp;
                </QuestionLabel>
                <Field
                    component={Text}
                    name={'DemandeDevis[ContactOrange][Email]'}
                    icon={'envelope'}
                    iconSize={18}
                    validate={[required, validateEmail]}
                    normalize={normalizeEmail}
                />
            </div>
        </div>
    </div>
);

export default ContactOrange;
